import { useIsFocused } from '@react-navigation/native';
import { lazy } from 'react';
import { adaptiveWrapperOptions } from '../../appComponents/ModalWrapper';
import { screenOptionsForLightMode } from '../../functions/navigation/screenOptions';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { SellerApplicationFlowProps } from './SellerApplicationFlow';

const SellerApplicationFlow = lazy(() => import('./SellerApplicationFlow'));

export default wrapLazyNavigatorScreen(
  (props: SellerApplicationFlowProps) => {
    const isFocused = useIsFocused();
    console.log('seller application focused: ', isFocused);
    return <SellerApplicationFlow {...props} />;
  },
  adaptiveWrapperOptions(isMobile =>
    isMobile
      ? screenOptionsForLightMode({
          presentation: 'card',
        })
      : screenOptionsForLightMode({
          presentation: 'transparentModal',
          cardOverlayEnabled: true,
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: false,
          headerShown: false,
        }),
  ),
  {
    title:
      'Monetize your social following with our managed creator commerce platform',
    description:
      'Start selling curated items from a 100,000+ items catalog of viral products to your followers today. We manage everything from sourcing, customer service and returns.',
  },
);
